/* eslint-disable default-param-last */
import { combineReducers } from 'redux';

const isWorking = (state = 0, action) => {
  switch (action.type) {
    case 'BEGIN_OPERATION': return state + 1;
    case 'END_OPERATION': return state - 1;
    default: return state;
  }
};

export const siteInfoInfoReducer = combineReducers({
  isWorking,
  initializing: (state = false, action) => (action.type === 'INITIALIZING' ? action.running : state),
});
